export const THUMB_HEIGHT = 240;
export const THUMB_WIDTH = 240;
export const COMPRESS_FILE_TYPE = 'image/jpeg';
export const QUALITY = 0.8;
export const CACHE_ADAY = 24 * 60 * 60;
export const ISSUE_IMAGE_BUCKET = process.env.REACT_APP_ISSUE_IMAGE_BUCKET ?? 'gooduncles-dev-images';
/** 이미지 업로드 공용 버킷 (경로로 서비스 구분) */
export const IMAGE_BUCKET = ISSUE_IMAGE_BUCKET;
/**
 * issue/
 *   case/{caseId}/
 *     original/{uuid}.{ext}
 *     thumbnail/{uuid}.{ext}
 *   task/{caseId}/{taskId}/
 *     original/{uuid}.{ext}
 *     thumbnail/{uuid}.{ext}
 */
export const ISSUE_CASE_PATH = 'issue/case';
export const ISSUE_TASK_PATH = 'issue/task';
/**
 * commerce-notice/{noticeId}/
 *   original/{uuid}.{ext}
 *   thumbnail/{uuid}.{ext}
 */
export const COMMERCE_NOTICE_PATH = 'commerce-notice';
